import React from "react";
import { Button } from "./Button.styles";
type ButtonProps = {
  onClick: () => void;
};
export const MuiButton: React.FC<ButtonProps> = ({ onClick }: ButtonProps) => {
  return <Button onClick={onClick}>Connection</Button>;
};
export default MuiButton;
